import React, { forwardRef } from 'react'

import { IconProps } from './types'

const SideBarOpenInverse = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      stroke={stroke || 'currentColor'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        className={color ? undefined : 'fill-[#787573] dark:fill-[#b6b2b0]'}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.999999 2V14H15V2H0.999999ZM2 3H11V13H2V3Z"
      />
    </svg>
  ),
)

SideBarOpenInverse.displayName = 'SideBarOpenInverse'

export default SideBarOpenInverse
